exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n@font-face {\r\n  font-family: 'password';\r\n  src: url(" + require("../fonts/password.woff2") + "),\r\n       url(" + require("../fonts/password.woff") + "),\r\n       url(" + require("../fonts/password.ttf") + ");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// E:/code/onedoorcloses/public_html/pricing/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!E:/code/onedoorcloses/public_html/pricing/node_modules/postcss-loader?{"ident":"postcss"}!E:/code/onedoorcloses/public_html/pricing/src/assets/css/bootstrap.min.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/css/bootstrap.min.css
// module chunks = styles